<template>
    <!-- <b-modal scrollable ref="mdlRsaSchedaRiferimentoDiagnostico" size="xl" title="Scheda riferimenti diagnostici" @ok="onSalvaRiferimentiDiagnostici" centered no-close-on-backdrop no-close-on-esc hide-header-close> -->
    <div class="sa-tab-scroll">
        <b-card class="sa-card sa-card-border" header="Riferimenti DX e TX" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Anamnesi patologica remota</label>
                    <span v-if="isReadOnly">{{ jsonData.anamnesiPatologicaRemota }}</span>
                    <b-form-input v-else v-model="jsonData.anamnesiPatologicaRemota" :readonly="isReadOnly"> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Anamnesi patologica prossima</label>
                    <span v-if="isReadOnly">{{ jsonData.anamnesiPatologicaProssima }}</span>
                    <b-form-input v-else v-model="jsonData.anamnesiPatologicaProssima" :readonly="isReadOnly"> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi in accesso</label>
                    <span v-if="isReadOnly">{{ jsonData.diagnosiAccesso }}</span>
                    <b-form-input v-else v-model="jsonData.diagnosiAccesso" :readonly="isReadOnly"> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Gruppo sanguigno</label>
                    <span v-if="isReadOnly">{{ jsonData.gruppoSanguigno }}</span>
                    <b-form-select v-else id="inline-form-custom-select-pref" v-model="jsonData.gruppoSanguigno" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="gruppoSanguignoOptions" :disabled="isReadOnly"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Note</label>
                    <span v-if="isReadOnly">{{ jsonData.note }}</span>
                    <b-form-textarea v-else v-model="jsonData.note" id="textarea-auto-height" placeholder="" rows="7" :readonly="isReadOnly"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card sa-card-border" header="Allergie" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-for="allergia in allergiaOptions" :key="/* 'ausilio-' +  */ allergia.id" class="sa-switch-select-element">
                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedAllergia" :value="allergia.voce" :readonly="isReadOnly" @change="onSelectCheckBoxAllergia">
                        <span style="font-weight: normal">{{ allergia.voce }}</span>
                        <!-- La voce delle checkbox sono bold in default quando uso b-form-checkbox, vanno gestite separatamente -->
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card sa-card-border" header="Positivita' sierologiche" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" v-for="sierolgia in sierologiaOptions" :key="sierolgia.id" class="sa-switch-select-element">
                    <b-form-checkbox switch :disabled="isReadOnly" v-model="selectedSierologia" :value="sierolgia.voce" :readonly="isReadOnly" @change="onSelectCheckBoxSierologia">
                        <span style="font-weight: normal">{{ sierolgia.voce }}</span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
    </div>

    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlRsaSchedaRiferimentoDiagnostico.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaRiferimentiDiagnostici()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlRsaSchedaRiferimentoDiagnostico.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    anamnesiPatologicaProssima: "",
                    anamnesiPatologicaRemota: "",
                    diagnosiAccesso: "",
                    gruppoSanguigno: "",
                    note: "",
                    listaAllergie: [],
                    listaPositivitaSierologiche: [],
                };
            },
        },
    },
    data() {
        return {
            linkback: "",
            isScalaValutazioneRiferimentiDiagnostici: true,
            listKey: 0,
            pathResource: "/rsaschedariferimentidiagnostici",
            pathResourceDizionario: "/rsadizionario",
            selectedAllergia: [],
            allergiaOptions: [],
            sierologiaOptions: [],
            selectedSierologia: [],
            isInternalUpdate: false, // Flag per distinguere aggiornamenti interni/esterni

            gruppoSanguignoOptions: [
                { text: "-Seleziona Valore-", value: "" },
                { text: "0 +", value: "0 +" },
                { text: "A +", value: "A +" },
                { text: "B +", value: "B +" },
                { text: "AB +", value: "AB +" },
                { text: "0 -", value: "0 -" },
                { text: "A -", value: "A -" },
                { text: "B -", value: "B -" },
                { text: "AB -", value: "AB -" },
                { text: "NON CONOSCIUTO", value: "NON CONOSCIUTO" },
            ],
            fieldsScaleValutazione: [
                {
                    label: "Tipo Scheda",
                    key: "tipoScheda",
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadAllergie();
        me.loadSierologie();
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler() {
                let me = this;
                if (me.isInternalUpdate) {
                    // console.log("Watch jsonData - popolo checkbox da dati esterni");
                    me.popolaCheckboxDaListe();
                    // console.log("isInternalUpdate: ", me.isInternalUpdate);
                }
                me.$emit("update", me.jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.resulResponseSuccess, me.resultResponseError);
            me.isInternalUpdate = true;
        },
        resulResponseSuccess(response) {
            let me = this;
            // me.jsonData = response.data.data;
            Object.keys(response.data.data).forEach((key) => {
                me.jsonData[key] = response.data.data[key];
            });

            me.jsonData.listaAllergie.forEach((element) => {
                me.allergiaOptions.forEach((item) => {
                    if (element.descrizione === item.voce) {
                        me.selectedAllergia.push(element.descrizione);
                    }
                });
            });
            me.jsonData.listaPositivitaSierologiche.forEach((element) => {
                me.sierologiaOptions.forEach((item) => {
                    if (element.descrizione === item.voce) {
                        me.selectedSierologia.push(element.descrizione);
                    }
                });
            });
        },
        resultResponseError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        popolaCheckboxDaListe() {
            let me = this;
            // console.log(" Popolo checkbox da liste - allergie:", me.jsonData.listaAllergie);
            // console.log(" Popolo checkbox da liste - sierologie:", me.jsonData.listaPositivitaSierologiche);

            me.selectedAllergia = [];
            me.selectedSierologia = [];

            if (me.jsonData.listaAllergie.length > 0) {
                me.jsonData.listaAllergie.forEach((element) => {
                    me.selectedAllergia.push(element.descrizione);
                    // console.log("Allergia aggiunta:", element.descrizione);
                });
            }

            if (me.jsonData.listaPositivitaSierologiche.length > 0) {
                me.jsonData.listaPositivitaSierologiche.forEach((element) => {
                    me.selectedSierologia.push(element.descrizione);
                    // console.log("------------------", me.selectedSierologia);
                    // console.log("Sierologia aggiunta:", element.descrizione);
                });
            }

            // console.log("selectedAllergia finale:", me.selectedAllergia);
            // console.log("selectedSierologia finale:", me.selectedSierologia);
        },
        onSelectCheckBoxAllergia() {
            let me = this;
            // console.log("Checkbox allergie cambiata:", me.selectedAllergia);
            me.isInternalUpdate = true;
            // Ricostruisci la lista allergie
            me.jsonData.listaAllergie = [];
            me.selectedAllergia.forEach((element) => {
                me.jsonData.listaAllergie.push({ descrizione: element });
            });
            // console.log("isInternalUpdate PRIMA DEL NEXTTICK: ", me.isInternalUpdate);

            // console.log("Lista allergie aggiornata:", me.jsonData.listaAllergie);
            me.$nextTick(() => {
                me.isInternalUpdate = false;
                // console.log("isInternalUpdate all'interno del NEXTTICK: ", me.isInternalUpdate);
            });
            // console.log("isInternalUpdate DOPO IL NEXTTICK: ", me.isInternalUpdate);
        },
        onSelectCheckBoxSierologia() {
            let me = this;
            // console.log("Checkbox sierologie cambiata:", me.selectedSierologia);

            me.isInternalUpdate = true;

            // Ricostruisci la lista sierologie
            me.jsonData.listaPositivitaSierologiche = [];
            me.selectedSierologia.forEach((element) => {
                me.jsonData.listaPositivitaSierologiche.push({ descrizione: element });
            });

            // console.log("Lista sierologie aggiornata:", me.jsonData.listaPositivitaSierologiche);

            me.$nextTick(() => {
                me.isInternalUpdate = false;
            });
        },
        onSalvaRiferimentiDiagnostici() {
            let me = this;
            me.jsonData.listaAllergie = [];
            me.jsonData.listaPositivitaSierologiche = [];

            me.selectedSierologia.forEach((element) => {
                me.jsonData.listaPositivitaSierologiche.push({ descrizione: element });
            });
            me.selectedAllergia.forEach((element) => {
                me.jsonData.listaAllergie.push({ descrizione: element });
            });
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, me.resultSaveResponse, me.resultSaveError);
        },

        loadSierologie() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, { tipo: "SIEROLOGIA" }, me.resultResponseSucceSierologie, me.resultResponseErrorSierologie);
        },
        resultResponseSucceSierologie(response) {
            let me = this;
            me.sierologiaOptions = [];
            me.sierologiaOptions = response.data.data.list;
        },
        resultResponseErrorSierologie(error) {
            console.log(error);
        },
        loadAllergie() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, { tipo: "ALLERGIA" }, me.resultResponseSuccessAllergie, me.resultResponseErrorAllergie);
        },
        resultResponseSuccessAllergie(response) {
            let me = this;
            me.allergiaOptions = [];
            me.allergiaOptions = response.data.data.list;
        },
        resultResponseErrorAllergie(error) {
            console.log(error);
        },
        /* controlloCmpScaleValutazione() {
            let me = this;
            const interval = setInterval(() => {
                if (me.$refs.cmpRsaSchedeValutazioneComponent) {
                    me.$refs.cmpRsaSchedeValutazioneComponent.init(me.idAccettazione, me.isScalaValutazioneRiferimentiDiagnostici);
                    clearInterval(interval);
                }
            }, 50);
        }, */
        /* show(value, isView) {
            let me = this;
            me.jsonData = { anamnesiPatologicaProssima: null, anamnesiPatologicaRemota: null, diagnosiAccesso: null, gruppoSanguigno: null, idAccettazione: me.idAccettazione, note: null, listaAllergie: [], listaPositivitaSierologiche: [] };
            me.selectedAllergia = [];
            me.controlloCmpScaleValutazione();
            me.isReadOnly = isView;
            if (value.compilata) {
                me.loadData();
            }
            me.loadAllergie();
            me.loadSierologie();
        }, */
        // resultSaveResponse() {
        //     let me = this;
        //     // me.$refs.mdlRsaSchedaRiferimentoDiagnostico.hide();
        //     me.$bvToast.toast("Salvataggio avvenuto con successo", {
        //         title: "Successo",
        //         variant: "success",
        //         solid: true,
        //     });
        //     me.$emit("onClose");
        // },
        // resultSaveError(response) {
        //     let me = this;
        //     if (response.response.status === 400) {
        //         me.$bvModal.msgBoxOk(response.response.data.messaggio, {
        //             title: "ATTEZIONE",
        //             size: "md",
        //             okVariant: "outline-secondary",
        //             headerClass: "sa-msg-header-danger",
        //             footerClass: "p-2 border-top-0",
        //             centered: true,
        //         });
        //     } else {
        //         me.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
        //             title: "Errore",
        //             variant: "danger",
        //             solid: true,
        //         });
        //     }
        // },
    },
};
</script>
